import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

/**
 * @param {string} [color]
 * @param {string} [direction]
 * @param {Node} [icon]
 * @param {string} [iconFontSize]
 * @param {function} [onClick]
 * @param {Node} title
 * @returns a MUI tooltip with a question mark icon as a target
 */
export default function TooltipIcon({
  color = "rgba(0,0,0,0.5)",
  direction = "top",
  icon = faQuestionCircle,
  iconFontSize = "16px",
  onClick,
  style = {},
  title,
}) {
  return (
    <Tooltip
      arrow
      placement={direction}
      sx={{ flexBasis: 0 }}
      title={<span style={{ fontSize: "12px" }}>{title}</span>}
    >
      <span
        style={{
          paddingLeft: "5px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          ...style,
        }}
      >
        <FontAwesomeIcon
          icon={icon}
          onClick={onClick}
          style={{
            color: color,
            fontSize: iconFontSize,
          }}
        />
      </span>
    </Tooltip>
  );
}

TooltipIcon.propTypes = {
  color: PropTypes.string,
  direction: PropTypes.string,
  icon: PropTypes.string,
  iconFontSize: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
  ]).isRequired,
};
